import { defineMessages } from 'react-intl';

export default defineMessages({
  report: 'Raport z wykonanych badań',
  reportDownload: 'Pobierz raport',
  anonymousClient: 'Klient anonimowy id {id}',
});
